import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import { api } from "@/lib/api";
import { useUtmCapture, withUtm } from "@/lib/utm";
import HeroSection from "./landing/HeroSection";
import PartnersSection from "./landing/PartnersSection";
import AboutSection from "./landing/AboutSection";
import LiveOpportunitySection from "./landing/LiveOpportunitySection";
import JourneySection from "./landing/JourneySection";
import RolesEcosystemSection from "./landing/RolesEcosystemSection";
import ImpactSection from "./landing/ImpactSection";
import AmbassadorsSection from "./landing/AmbassadorsSection";
import ClosingSection from "./landing/ClosingSection";
import SimpleFooter from "./landing/SimpleFooter";

export default function Landing() {
  useUtmCapture();
  const navigate = useNavigate();
  const [oppCount, setOppCount] = useState(null);
  const [opps, setOpps] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [landing, setLanding] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/opportunities?status=published");
        setOpps(data.opportunities || []);
        setOppCount((data.opportunities || []).length);
      } catch {
        setOppCount(0);
      }
      try {
        const { data } = await api.get("/public/landing");
        setLanding(data);
      } catch {
        setLanding(null);
      }
    })();
  }, []);

  const submitSearch = (e) => {
    e?.preventDefault();
    const q = searchTerm.trim();
    const to = q ? `/opportunities?q=${encodeURIComponent(q)}` : "/opportunities";
    navigate(withUtm(to));
  };

  return (
    <div className="min-h-screen bg-cream-50" data-testid="landing-page">
      <PublicNav />
      <HeroSection
        oppCount={oppCount}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        submitSearch={submitSearch}
      />
      <PartnersSection partners={landing?.partners_list} />
      <AboutSection />
      <LiveOpportunitySection opps={opps} />
      <JourneySection />
      <RolesEcosystemSection />
      <ImpactSection landing={landing} />
      <AmbassadorsSection ambassadors={landing?.ambassadors_list} />
      <ClosingSection />
      <SimpleFooter />
    </div>
  );
}
